'use es6';

import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import { getApiClient } from '../utils/apiClient';
let apiBase = 'ecosystem/v1';
const adminApiBase = 'ecosystem/admin/v1';
export const setApiBase = base => {
  apiBase = base;
};
export const getAppIntegrations = () => {
  return getApiClient().get(`${apiBase}/apps/tags/app-integrations`);
};
export const searchApps = ({
  language,
  queries,
  showPreferredLanguageFirst = false
}, opts = {}) => {
  return getApiClient().post(`${apiBase}/apps/search`, Object.assign({}, opts, {
    data: {
      language,
      showPreferredLanguageFirst,
      queries
    }
  }));
};
export const details = (slug, language) => getApiClient().get(`${apiBase}/apps/details`, {
  query: {
    slug,
    language
  }
});
export const detailsPreview = (slug, language, base = apiBase) => getApiClient().get(`${base}/apps/details/preview`, {
  query: {
    slug,
    language
  }
});
export const detailsAdminPreview = (slug, language) => detailsPreview(slug, language, adminApiBase);
export const fetchInstallability = offeringId => getApiClient().get(`${apiBase}/apps/${offeringId}/installability`);
export const fetchCompatibility = () => getApiClient().get(`${apiBase}/compatibility/ops-hub`);
export const fetchReviewability = offeringId => getApiClient().get(`${apiBase}/reviews/reviewability/offerings/${offeringId}`);
export const emailAdmin = (adminUserId, listingId, permissions) => {
  return getApiClient().post(`${apiBase}/permissions/request-from-admin`, {
    data: {
      adminUserId,
      listingId,
      permissions
    }
  });
};
export const fetchReviews = queries => {
  return getApiClient().post(`${apiBase}/reviews/search`, {
    data: Object.assign({
      reviewType: ReviewTypes.APP
    }, queries)
  });
};
export const fetchReviewsStats = offeringId => getApiClient().post(`${apiBase}/reviews/stats`, {
  data: {
    offeringId,
    reviewType: ReviewTypes.APP
  }
});
export const writeReview = review => {
  return getApiClient().post(`${apiBase}/reviews`, {
    data: review
  });
};
export const toggleReviewHelpful = (reviewId, isHelpful) => getApiClient().put(`${apiBase}/reviews/${reviewId}/helpful`, {
  data: isHelpful
});
export const reportReview = ({
  reviewId,
  reason,
  comment
}) => getApiClient().post(`${apiBase}/reviews/${reviewId}/report`, {
  data: {
    reason,
    comment
  }
});
export const reportReply = ({
  reviewId,
  replyId,
  reason,
  comment
}) => getApiClient().post(`${apiBase}/reviews/${reviewId}/replies/${replyId}/report`, {
  data: {
    reason,
    comment
  }
});
export const fetchFeaturedCallouts = () => {
  return getApiClient().get(`${apiBase}/self-serve/callouts/published`);
};
export const fetchPublishedCollections = isAdminPreview => {
  const base = isAdminPreview ? adminApiBase : apiBase;
  return getApiClient().get(`${base}/self-serve/apps/collections${!isAdminPreview ? '/published' : ''}`);
};
export const fetchCollectionItems = (collectionId, query, isAdminPreview) => {
  const base = isAdminPreview ? adminApiBase : apiBase;
  return getApiClient().get(`${base}/self-serve/apps/collections/${collectionId}/items`, {
    query
  });
};